import { jwtDecode, JwtPayload } from 'jwt-decode'
import { logger } from './logger'

const SESSION_STORAGE_TOKEN_KEY = 'sessionToken'
const ID_TOKEN_KEY = 'idToken'

export const setSessionToken = (token: string) => {
  // Temporarily log when the session token is updated, and what the expiration
  // time is, for debugging purposes.
  try {
    const decoded = jwtDecode<JwtPayload>(token)
    logger.debug(`[Session] Updated session token with expiration ${decoded.exp}`)
  } catch (e) {
    logger.error('[Session] Could not parse token', e)
  }
  sessionStorage.setItem(SESSION_STORAGE_TOKEN_KEY, token)
}

export const setIdToken = (token: string) => {
  sessionStorage.setItem(ID_TOKEN_KEY, token)
}
export const getSessionToken = () => sessionStorage.getItem(SESSION_STORAGE_TOKEN_KEY)
export const removeSessionToken = () => sessionStorage.removeItem(SESSION_STORAGE_TOKEN_KEY)
export const getIdToken = () => sessionStorage.getItem(ID_TOKEN_KEY)
export const removeIdToken = () => sessionStorage.removeItem(ID_TOKEN_KEY)

/**
 * The `exp` claim of a JWT, in seconds. Throws when the token carries none: every caller
 * refreshes or logs out on failure, which is the right outcome for a token whose lifetime
 * cannot be read.
 */
export const tokenExpiresAt = (token: string): number => {
  const { exp } = jwtDecode(token)
  if (exp == null) {
    throw new Error('Token has no exp claim')
  }
  return exp
}

/** The access token from Auth0's `getAccessTokenSilently`, which types an absent token as `undefined`. */
export const requireAccessToken = (token: string | undefined): string => {
  if (token == null) {
    throw new Error('Auth0 returned no access token')
  }
  return token
}
